import * as Yup from "yup";
import { cpf } from "cpf-cnpj-validator";

import {
  isInvalidBirthDate,
  hasBlankSpace,
  hasOnlyLetters,
} from "../../../../Utils";
import { InputTypes } from "../UserData.screen";

const regexPasswordRequired =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

const schemaDocument = () =>
  Yup.string()
    .test(
      "cpf",
      "Número inválido. Por favor digite um CPF válido",
      (value = "") => cpf.isValid(value)
    )
    .required("CPF obrigatório");

const schemaBirthdate = () =>
  Yup.string()
    .test("birthdate", (value = "", { createError, path }) => {
      const error = isInvalidBirthDate(value);
      if (error)
        return createError({
          path,
          message: error,
        });
      else return true;
    })
    .required("Data de nascimento obrigatória");

const schemaCellphoneNumber = () =>
  Yup.string()
    .min(16, "Número de celular incorreto")
    .max(16, "Número de celular incorreto")
    .required("Número de celular obrigatório");

const schemaUsername = () =>
  Yup.string()
    .test("username", "Apenas letras são permitidas", (value = "") =>
      hasOnlyLetters(value)
    )
    .test(
      "username",
      "Não são permitidos espaços em branco",
      (value = "") => !hasBlankSpace(value)
    )
    .min(4, "O usuário precisa ter no mínimo 4 caracteres")
    .required("Nome de usuário obrigatório");

const schemaPassword = () =>
  Yup.string()
    .matches(
      regexPasswordRequired,
      "Deve conter 8 caracteres, uma letra maiúscula, uma letra minúscula, um número e um caractere especial"
    )
    .test(
      "password",
      "Não são permitidos espaços em branco",
      (value = "") => !hasBlankSpace(value)
    )
    .required("Senha obrigatória");

const inputSchemaValidation: {
  [key in InputTypes]: any;
} = {
  cpf: schemaDocument,
  birthdate: schemaBirthdate,
  cell_phone_number: schemaCellphoneNumber,
  username: schemaUsername,
  password: schemaPassword,
};

export const validateInput =
  ({ name }: { name: InputTypes | "all" }) =>
  async (fieldsFormData: Record<string, any> | undefined) => {
    let shape: { [key in InputTypes]?: any } = {};

    if (name === "all") {
      let key: InputTypes;
      for (key in inputSchemaValidation) {
        shape[key] = inputSchemaValidation[key]();
      }
    } else {
      shape = { [name]: inputSchemaValidation[name]() };
    }

    const schema = Yup.object().shape(shape);

    await schema.validate(fieldsFormData, {
      abortEarly: false,
    });
  };
